import React, { useState, useEffect } from 'react';
import ButtonWrapper from '@components/common/ButtonWrapper';
import { initSelectors } from '@behavior/init';
import { entityType as et } from '../../../../../constants';
import { useTranslation } from 'react-i18next';
import useUser from '@behavior/init/getUserV2';

type Props = {
  entityType: string;
  handleAddNewRecord: () => void;
};

const AddNewRecord = ({ entityType, handleAddNewRecord }: Props) => {
  const { t } = useTranslation();
  const { user } = useUser();
  const isInventoryOrChemProductCanCreate = initSelectors.isInventoryOrChemProductCanCreate(
    user,
    entityType
  );
  if (isInventoryOrChemProductCanCreate) {
    if (entityType === et.inventory && isInventoryOrChemProductCanCreate) {
      return (
        <ButtonWrapper
          label={t('inventory.overview.page.add.new.inventory')}
          type="button"
          color="green"
          icon="plus"
          onClick={handleAddNewRecord}
        />
      );
    }
    if (entityType === et.product && isInventoryOrChemProductCanCreate) {
      return (
        <ButtonWrapper
          label={t('inventory.overview.page.add.new.product')}
          type="button"
          color="green"
          className="tiny"
          icon="plus"
          onClick={handleAddNewRecord}
        />
      );
    }
  }

  return <></>;
};

export default AddNewRecord;
